import { OrderByInput, useExportAssets } from '@gripp/shared-logic';
import { ColumnDef } from '@tanstack/react-table';
import { useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { Pressable, StyleSheet } from 'react-native';
import { IconButton } from 'react-native-paper';
import { Colors } from '../../themes';
import { SaveIcon } from '../crop-circle/icons/saveIcon';

type ExportButtonProps = {
  fileName: string;
  query: any;
  filter: any;
  orderBy: OrderByInput;
  dataPrefix: string;
  columns: ColumnDef<any, any>[];
  useCropCircle?: boolean;
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
export const DataGridExportButton = ({
  useCropCircle,
  ...props
}: ExportButtonProps) => {
  // TODO: Crop Circle Redesign | Remove after feature is fully rolled out
  if (!useCropCircle) {
    return <DataGridExportButtonOld {...props} />;
  }

  // TODO: Crop Circle Redesign | Remove to DataGridExportButtonBase after feature is fully rolled out
  return <DataGridExportButtonBase {...props} />;
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const DataGridExportButtonOld = (props: ExportButtonProps) => {
  const csvRef = useRef<any>(null);
  const [download, toggleDownload] = useState(false);

  const onDataReady = () => {
    if (download) {
      doDownload();
    }
  };

  const { headers, rows, isLoading } = useExportAssets({
    query: props.query,
    filter: props.filter,
    orderBy: props.orderBy,
    dataPrefix: props.dataPrefix,
    columns: props.columns,
    download: download,
    onDataReady: onDataReady,
  });

  const doDownload = () => {
    setTimeout(() => {
      csvRef.current?.link.click();
      toggleDownload(false);
    }, 50);
  };

  const onDownload = () => {
    toggleDownload(true);
  };

  return (
    <>
      <IconButton
        icon="download"
        iconColor={isLoading ? Colors.grayDisabled : Colors.orangeDark}
        onPress={onDownload}
        disabled={isLoading}
        style={oldStyles.icon}
        size={25}
      />
      <CSVLink
        data={rows}
        headers={headers}
        filename={`${props.fileName}.csv`}
        ref={csvRef}
      />
    </>
  );
};

const DataGridExportButtonBase = (props: ExportButtonProps) => {
  const csvRef = useRef<any>(null);
  const [download, toggleDownload] = useState(false);

  const onDataReady = () => {
    if (download) {
      doDownload();
    }
  };

  const { headers, rows, isLoading } = useExportAssets({
    query: props.query,
    filter: props.filter,
    orderBy: props.orderBy,
    dataPrefix: props.dataPrefix,
    columns: props.columns,
    download: download,
    onDataReady: onDataReady,
  });

  const doDownload = () => {
    setTimeout(() => {
      csvRef.current?.link.click();
      toggleDownload(false);
    }, 50);
  };

  const onDownload = () => {
    toggleDownload(true);
  };

  return (
    <>
      <Pressable
        onPress={onDownload}
        disabled={isLoading}
        style={baseStyles.icon}
      >
        <SaveIcon
          size={20}
          color={isLoading ? Colors.grayDisabled : Colors.blackText}
        />
      </Pressable>
      <CSVLink
        data={rows}
        headers={headers}
        filename={`${props.fileName}.csv`}
        ref={csvRef}
      />
    </>
  );
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const oldStyles = StyleSheet.create({
  icon: {
    margin: 0,
  },
});

const baseStyles = StyleSheet.create({
  icon: {
    margin: 0,
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
